import { takeLatest, put, call } from "redux-saga/effects";
import {
  GET_APPLICATIONS_SERVICE_REQUEST,
  GET_APPLICATIONS_SERVICE_SUCCESS,
  GET_APPLICATIONS_SERVICE_FAILURE,
  GET_APPLICATION_BY_ID_SERVICE_REQUEST,
  GET_APPLICATION_BY_ID_SERVICE_SUCCESS,
  GET_APPLICATION_BY_ID_SERVICE_FAILURE,
  UPDATE_APPLICATION_STATUS_SERVICE_REQUEST,
  UPDATE_APPLICATION_STATUS_SERVICE_SUCCESS,
  UPDATE_APPLICATION_STATUS_SERVICE_FAILURE,
  DELETE_APPLICATION_SERVICE_REQUEST,
  DELETE_APPLICATION_SERVICE_SUCCESS,
  DELETE_APPLICATION_SERVICE_FAILURE,
  CREATE_APPLICATION_SERVICE_REQUEST,
  CREATE_APPLICATION_SERVICE_SUCCESS,
  CREATE_APPLICATION_SERVICE_FAILURE,
  getApplicationsServiceRequest, // <-- ekledim
} from "./actions";
import {
  getApplications,
  getApplicationById,
  updateApplicationStatus,
  deleteApplication,
  createApplication,
} from "../../api/application";

// Application listesi
function* getApplicationsSaga() {
  try {
    const response = yield call(getApplications);
    console.log("Saga Response:", response); // Saga yanıtını kontrol etmek için
    if (response && response.data && response.data.body && response.data.body.result) {
      yield put({
        type: GET_APPLICATIONS_SERVICE_SUCCESS,
        payload: response.data.body.result,
      });
    } else {
      throw new Error("API yanıtı geçersiz");
    }
  } catch (error) {
    console.error("Saga Error:", error); // Hata detaylarını görmek için
    yield put({
      type: GET_APPLICATIONS_SERVICE_FAILURE,
      payload: error.message || "Veri alınamadı",
    });
  }
}

// Tek bir application getirme
function* getApplicationByIdSaga(action) {
  try {
    const response = yield call(getApplicationById, action.payload);
    console.log("Saga Response:", response);
    if (response && response.data) {
      yield put({
        type: GET_APPLICATION_BY_ID_SERVICE_SUCCESS,
        payload: response.data,
      });
    } else {
      throw new Error("API yanıtı geçersiz");
    }
  } catch (error) {
    console.error("Saga Error:", error);
    yield put({
      type: GET_APPLICATION_BY_ID_SERVICE_FAILURE,
      payload: error.message || "Veri alınamadı",
    });
  }
}

// Application durumu güncelleme
function* updateApplicationStatusSaga(action) {
  try {
    const response = yield call(updateApplicationStatus, action.payload);
    console.log("Saga Response:", response);
    if (response && response.data) {
      yield put({
        type: UPDATE_APPLICATION_STATUS_SERVICE_SUCCESS,
        payload: response.data,
      });
    } else {
      throw new Error("API yanıtı geçersiz");
    }
  } catch (error) {
    console.error("Saga Error:", error);
    yield put({
      type: UPDATE_APPLICATION_STATUS_SERVICE_FAILURE,
      payload: error.message || "Güncelleme başarısız",
    });
  }
}


// Application silme
function* deleteApplicationSaga(action) {
  try {
    const response = yield call(deleteApplication, action.payload);
    console.log("Saga Response:", response);
    if (response && response.data) {
      yield put({
        type: DELETE_APPLICATION_SERVICE_SUCCESS,
        payload: action.payload, // id gönderiliyor
      });
    } else {
      throw new Error("API yanıtı geçersiz");
    }
  } catch (error) {
    console.error("Saga Error:", error);
    yield put({
      type: DELETE_APPLICATION_SERVICE_FAILURE,
      payload: error.message || "Silme işlemi başarısız",
    });
  }
}

function* createApplicationSaga(action) {
  try {
    const response = yield call(createApplication, action.payload);
    if (response && response.data) {
      yield put({
        type: CREATE_APPLICATION_SERVICE_SUCCESS,
        payload: response.data,
      });
      // Ekleme başarılıysa uygulama listesini tekrar çek
      yield put(getApplicationsServiceRequest());
    } else {
      throw new Error("API yanıtı geçersiz");
    }
  } catch (error) {
    yield put({
      type: CREATE_APPLICATION_SERVICE_FAILURE,
      payload: error.message || "Oluşturma başarısız",
    });
  }
}

export default function* applicationSaga() {
  yield takeLatest(GET_APPLICATIONS_SERVICE_REQUEST, getApplicationsSaga);
  yield takeLatest(GET_APPLICATION_BY_ID_SERVICE_REQUEST, getApplicationByIdSaga);
  yield takeLatest(UPDATE_APPLICATION_STATUS_SERVICE_REQUEST, updateApplicationStatusSaga);
  yield takeLatest(DELETE_APPLICATION_SERVICE_REQUEST, deleteApplicationSaga);
  yield takeLatest(CREATE_APPLICATION_SERVICE_REQUEST, createApplicationSaga);
} 